import React, { useCallback } from 'react';
import { CardView, SettingsItemNavigate } from 'design-system';
import { IconChat } from 'design-system/icons';
import IconBoldQuestion from 'design-system/icons/IconBoldQuestion';
import Links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const strings = {
    needAssistance: 'Need assistance with your account?',
    chatWithSupport: 'Chat with support',
    visitHelpdesk: 'Visit helpdesk',
};
const onPressHelpdesk = () => {
    Links.openEmmaHelp();
};
const DeleteNeedAssitanceCard = () => {
    const navigation = useMainStackNavigation();
    const onPressSupport = useCallback(() => {
        navigation.navigateDeprecated('Support', {});
    }, []);
    return (<CardView title={strings.needAssistance} noMarginTop>
      <SettingsItemNavigate title={strings.chatWithSupport} icon={<IconChat colorKey="brand"/>} onPress={onPressSupport}/>
      <SettingsItemNavigate title={strings.visitHelpdesk} icon={<IconBoldQuestion gradientKey="darkPink"/>} onPress={onPressHelpdesk}/>
    </CardView>);
};
export default DeleteNeedAssitanceCard;
